import { render } from "./SublistElement.vue?vue&type=template&id=54b387c6"
import script from "./SublistElement.vue?vue&type=script&lang=js"
export * from "./SublistElement.vue?vue&type=script&lang=js"

import "./SublistElement.vue?vue&type=style&index=0&id=54b387c6&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__